import { SpectrumColor } from '../types';

export const Turquoise: SpectrumColor = {
  0: '#F2FDFD',
  5: '#E5FAFA',
  10: '#CFF7F7',
  15: '#BDF3F3',
  20: '#9BE8E8',
  25: '#84E4E4',
  30: '#59D9D9',
  35: '#46CECE',
  40: '#2DC2C2',
  50: '#28AFAF',
  60: '#1F9E9E',
  70: '#0F8A8A',
  80: '#166F6F',
  90: '#0A5C5C',
  100: '#0E4343',
  110: '#0C3131',
  default: 70,
};
